import React, { useEffect, useState } from "react";
import styles from "./ErrorPageNew.module.scss";
import { URL_MAIL, URL_MAX } from '~/new-ui-customer-questionnaire/constants/documentFields'


interface Props {
	isChunkLoadError?: boolean;
}

export const ErrorPageNew = ({ isChunkLoadError }: Props = {}) => {
	const [visible, setVisible] = useState(false);

	useEffect(() => {
		// даем браузеру отрисовать фон, затем плавно показываем карточку
		requestAnimationFrame(() => setVisible(true));
	}, []);

	return (
		<div className={styles.wrapper}>
			<div
				className={`${styles.card} ${visible ? styles.enter : ""}`}
				role="alert"
				aria-live="polite"
			>
				<div className={styles.icon} aria-hidden>
					<svg
						viewBox="0 0 64 64"
						width="64"
						height="64"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<defs>
							<linearGradient id="errorGradient" x1="0" y1="0" x2="1" y2="1">
								<stop offset="0%" stopColor="#ff84d1" />
								<stop offset="100%" stopColor="#8fa5ff" />
							</linearGradient>
						</defs>

						<circle
							cx="32"
							cy="32"
							r="28"
							className={styles.iconBg}
						/>

						<path
							d="M22 22L42 42M42 22L22 42"
							stroke="url(#errorGradient)"
							strokeWidth="3"
							strokeLinecap="round"
						/>
					</svg>

				</div>


				<h1 className={styles.title}>
					{isChunkLoadError ? "Вышла новая версия сайта" : "Что-то пошло не по плану"}
				</h1>

				<p className={styles.subtitle}>
					{isChunkLoadError ? (
						<>
							Пока вы заполняли анкету, мы обновили сайт.
							<br />
							Обновите страницу, чтобы продолжить — данные шага не потеряются.
						</>
					) : (
						<>
							Мы не смогли корректно завершить действие.
							<br />
							Данные сохранены - команда уже получила сигнал.
						</>
					)}
				</p>

				<div className={styles.actions}>
					<button
						className={styles.primary}
						onClick={() => window.location.reload()}
					>
						{isChunkLoadError ? "Обновить страницу" : "Повторить попытку"}
					</button>

					<span className={styles.hint}>
						Обычно это занимает меньше минуты
					</span>
				</div>

				<div className={styles.contactLinks}>
					<a
						href={URL_MAX}
						target="_blank"
						rel="noopener noreferrer"
						className={`${styles.contactLink} ${styles.maxLink}`}
						title="Написать в MAX"
					>
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 377 100" fill="none"><path fill="currentColor" fillRule="evenodd" d="M50.76 0c27.53 0 49.12 22.34 49.12 49.89S77.61 99.23 51.02 99.23c-9.43 0-14.01-1.33-21.37-6.54-.5-.36-1.2-.26-1.63.19-5.66 6.04-20.17 10.28-20.83 2.03C7.19 80.53 0 71.18 0 49.61 0 21.3 23.22 0 50.76 0m.77 24.55c-13.07-.68-23.26 8.39-25.51 22.58-1.86 11.75 1.44 26.07 4.26 26.8 1.2.3 4.08-1.9 6.18-3.88.4-.37.99-.44 1.45-.15 3.27 2 6.97 3.5 11.05 3.71 13.42.7 25.3-9.8 26-23.21.71-13.42-10.01-25.14-23.43-25.85" clipRule="evenodd"></path><path fill="currentColor" d="M349.55 78.2a31 31 0 0 1-15.16-3.69q-6.71-3.78-10.5-10.39a31 31 0 0 1-3.68-15.16q0-8.44 3.68-15.04a26.5 26.5 0 0 1 10.5-10.4 30.3 30.3 0 0 1 15.16-3.79q9.3 0 16.45 4.66a24.7 24.7 0 0 1 10.29 12.99l-11.7 1.95a14 14 0 0 0-5.73-5.96 16.3 16.3 0 0 0-8.56-2.27q-7.57 0-12.34 4.98t-4.76 12.88q0 7.9 4.76 12.89t12.35 4.98q4.97 0 8.87-2.28a15.5 15.5 0 0 0 5.85-6.17l11.7 1.95a25 25 0 0 1-10.51 13.21 31 31 0 0 1-16.67 4.66"></path><path fill="currentColor" d="M323.72 77.11h-16.35l-19.48-22.4h-3.03v22.4H272.4v-56.3h12.46v21.87h3.03l18.84-21.86h14.83l-23.71 27.06zM228.22 78.2q-7.9 0-14.18-3.69-6.28-3.78-9.85-10.39a32.6 32.6 0 0 1-3.47-15.16q0-8.44 3.47-15.04a26 26 0 0 1 9.85-10.4 27 27 0 0 1 14.18-3.79q7.04 0 12.45 3.03a29 29 0 0 1 8.88 7.15l2.6-9.1h9.3v56.3h-9.3l-2.6-9.1a31 31 0 0 1-8.88 7.26 26 26 0 0 1-12.45 2.93m3.03-11.16q7.9 0 12.78-4.98 4.98-5.09 4.98-13.1t-4.98-12.99q-4.87-5.09-12.78-5.09-7.8 0-12.67 5.1-4.87 4.97-4.87 12.98t4.87 13.1q4.87 4.98 12.67 4.98M136.7 77.11h-11.92v-56.3h19.38l13 38.66h1.73l13.53-38.65h18.95v56.3h-11.91v-41.8h-1.74L163 77.12h-10.5l-14.08-41.8h-1.73z"></path></svg>
					</a>

					<a
						href={URL_MAIL}
						className={styles.contactLink}
						title="Отправить письмо"
					>
						<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2">
							<rect x="2" y="4" width="20" height="16" rx="2"></rect>
							<path d="M 2 6 l 10 7 l 10 -7"></path>
						</svg>
						Письмо
					</a>
				</div>
			</div>
		</div>
	);
};
